import { render, staticRenderFns } from "./keywordExamine.vue?vue&type=template&id=64d448ab&scoped=true"
import script from "./keywordExamine.vue?vue&type=script&lang=ts"
export * from "./keywordExamine.vue?vue&type=script&lang=ts"
import style1 from "./keywordExamine.vue?vue&type=style&index=1&id=64d448ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d448ab",
  null
  
)

export default component.exports